import { Time } from './Time';

export class Interval {
  constructor(interval) {
    const context = { id: interval.id };

    this.id = interval.id;
    this.from = new Time(interval.time, context);
    this.to = new Time(
      addDuration(this.from.minutes, interval.duration),
      context
    );
    this.duration = interval.duration;

    this.hasIntersection = this.hasIntersection.bind(this);
  }

  hasIntersection(interval) {
    if (!interval) return false;

    return (
      this.from.minutes < interval.to.minutes &&
      this.to.minutes > interval.from.minutes
    );
  }
}

function padZero(num) {
  return `${num < 10 ? '0' : ''}${num}`;
}

function addDuration(timeInMin, duration) {
  const total = timeInMin + duration;

  const h = Math.floor(total / 60) % 24;

  const m = total % 60;

  return `${padZero(h)}:${padZero(m)}`;
}
